import { BlockType } from '..';

const FeedBlocks: Record<string, () => BlockType> = {};
if (process.env.TARGET == 'admin' || process.env.BROWSER != 'true') {
	FeedBlocks['feeds/ical'] = () => require('./ical/index').default;
	FeedBlocks['feeds/youtube-channel'] = () => require('./youtube-channel/index').default;
	FeedBlocks['feeds/search-result'] = () => require('./search-result/index').default;
}

export default FeedBlocks;